import React, { useState, useEffect } from "react"
import queryString from "query-string"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import PropTypes from "prop-types"
import { payfipConfirmation } from "../constants"

const PaiementResultPage = (props) => {
  const [resultPayfip, setresultPayfip] = useState("")
  const params = queryString.parse(props.location.search)
  useEffect(() => {
    if (!params.idop) {
      setresultPayfip("NO_PARAMS")
      return
    }
    const url =
      process.env.GATSBY_ESPACE_CITOYEN_URL +
      "/" +
      payfipConfirmation +
      "/" +
      params.idop
    fetch(url)
      .then((response) => response.text())
      .then((resultData) => {
        setresultPayfip(resultData)
      })
  }, [params])

  const RenderMessage = () => {
    if (!resultPayfip) return null
    let message
    switch (resultPayfip) {
      case "PAYÉ": {
        message = "Votre paiement a été finalisé avec succès."
        break
      }
      case "ANNULÉ": {
        message = "Votre demande de paiement a été annulée ou a expirée."
        break
      }
      case "REFUSÉ": {
        message = "Votre paiement a été refusé."
        break
      }
      case "NO_PARAMS": {
        message = "Requête incorrecte"
        break
      }
      default: {
        message = "Votre paiement n'a pas pu aboutir : " + resultPayfip
        break
      }
    }
    return <p>{message}</p>
  }

  return (
    <Layout>
      <SEO title="Résultat Paiement" />
      <div
        style={{
          padding: "2.25rem 15% 1rem 15%",
        }}
      >
        {RenderMessage()}
      </div>
    </Layout>
  )
}

//-----------------------Prop-Types---------------------------//

PaiementResultPage.propTypes = {
  location: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default PaiementResultPage
